export default {"src":"/_next/static/media/hexwrenchCar_40.b13229cd.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};